export default "__VITE_ASSET__DevlkgNT__"